/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as InboxRouteImport } from './routes/inbox'
import { Route as InviteRouteImport } from './routes/invite'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SearchRouteImport } from './routes/search'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ViewsRouteImport } from './routes/views'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminAuditRouteImport } from './routes/admin/audit'
import { Route as AdminAutomationsRouteImport } from './routes/admin/automations'
import { Route as AdminExportRouteImport } from './routes/admin/export'
import { Route as AdminGroupsRouteImport } from './routes/admin/groups'
import { Route as AdminLookupsRouteImport } from './routes/admin/lookups'
import { Route as AdminTokensRouteImport } from './routes/admin/tokens'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as CardNumberRouteImport } from './routes/card.$number'
import { Route as ProjectsIndexRouteImport } from './routes/projects/index'
import { Route as ProjectsKeyRouteImport } from './routes/projects/$key'
import { Route as ReportsIndexRouteImport } from './routes/reports/index'
import { Route as ReportsDashboardRouteImport } from './routes/reports/$dashboard'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxRoute = InboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteRoute = InviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ViewsRoute = ViewsRouteImport.update({
  id: '/views',
  path: '/views',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAutomationsRoute = AdminAutomationsRouteImport.update({
  id: '/automations',
  path: '/automations',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminExportRoute = AdminExportRouteImport.update({
  id: '/export',
  path: '/export',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminGroupsRoute = AdminGroupsRouteImport.update({
  id: '/groups',
  path: '/groups',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminLookupsRoute = AdminLookupsRouteImport.update({
  id: '/lookups',
  path: '/lookups',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminTokensRoute = AdminTokensRouteImport.update({
  id: '/tokens',
  path: '/tokens',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRouteRoute,
} as any)
const CardNumberRoute = CardNumberRouteImport.update({
  id: '/card/$number',
  path: '/card/$number',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsKeyRoute = ProjectsKeyRouteImport.update({
  id: '/projects/$key',
  path: '/projects/$key',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsIndexRoute = ReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsDashboardRoute = ReportsDashboardRouteImport.update({
  id: '/reports/$dashboard',
  path: '/reports/$dashboard',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/inbox': typeof InboxRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/views': typeof ViewsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/automations': typeof AdminAutomationsRoute
  '/admin/export': typeof AdminExportRoute
  '/admin/groups': typeof AdminGroupsRoute
  '/admin/lookups': typeof AdminLookupsRoute
  '/admin/tokens': typeof AdminTokensRoute
  '/admin/users': typeof AdminUsersRoute
  '/card/$number': typeof CardNumberRoute
  '/projects/$key': typeof ProjectsKeyRoute
  '/reports/$dashboard': typeof ReportsDashboardRoute
  '/admin/': typeof AdminIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/reports/': typeof ReportsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/inbox': typeof InboxRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/views': typeof ViewsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/automations': typeof AdminAutomationsRoute
  '/admin/export': typeof AdminExportRoute
  '/admin/groups': typeof AdminGroupsRoute
  '/admin/lookups': typeof AdminLookupsRoute
  '/admin/tokens': typeof AdminTokensRoute
  '/admin/users': typeof AdminUsersRoute
  '/card/$number': typeof CardNumberRoute
  '/projects/$key': typeof ProjectsKeyRoute
  '/reports/$dashboard': typeof ReportsDashboardRoute
  '/admin': typeof AdminIndexRoute
  '/projects': typeof ProjectsIndexRoute
  '/reports': typeof ReportsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/inbox': typeof InboxRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/views': typeof ViewsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/automations': typeof AdminAutomationsRoute
  '/admin/export': typeof AdminExportRoute
  '/admin/groups': typeof AdminGroupsRoute
  '/admin/lookups': typeof AdminLookupsRoute
  '/admin/tokens': typeof AdminTokensRoute
  '/admin/users': typeof AdminUsersRoute
  '/card/$number': typeof CardNumberRoute
  '/projects/$key': typeof ProjectsKeyRoute
  '/reports/$dashboard': typeof ReportsDashboardRoute
  '/admin/': typeof AdminIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/reports/': typeof ReportsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/inbox'
    | '/invite'
    | '/login'
    | '/search'
    | '/settings'
    | '/views'
    | '/admin/audit'
    | '/admin/automations'
    | '/admin/export'
    | '/admin/groups'
    | '/admin/lookups'
    | '/admin/tokens'
    | '/admin/users'
    | '/card/$number'
    | '/projects/$key'
    | '/reports/$dashboard'
    | '/admin/'
    | '/projects/'
    | '/reports/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/inbox'
    | '/invite'
    | '/login'
    | '/search'
    | '/settings'
    | '/views'
    | '/admin/audit'
    | '/admin/automations'
    | '/admin/export'
    | '/admin/groups'
    | '/admin/lookups'
    | '/admin/tokens'
    | '/admin/users'
    | '/card/$number'
    | '/projects/$key'
    | '/reports/$dashboard'
    | '/admin'
    | '/projects'
    | '/reports'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/inbox'
    | '/invite'
    | '/login'
    | '/search'
    | '/settings'
    | '/views'
    | '/admin/audit'
    | '/admin/automations'
    | '/admin/export'
    | '/admin/groups'
    | '/admin/lookups'
    | '/admin/tokens'
    | '/admin/users'
    | '/card/$number'
    | '/projects/$key'
    | '/reports/$dashboard'
    | '/admin/'
    | '/projects/'
    | '/reports/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  InboxRoute: typeof InboxRoute
  InviteRoute: typeof InviteRoute
  LoginRoute: typeof LoginRoute
  SearchRoute: typeof SearchRoute
  SettingsRoute: typeof SettingsRoute
  ViewsRoute: typeof ViewsRoute
  CardNumberRoute: typeof CardNumberRoute
  ProjectsKeyRoute: typeof ProjectsKeyRoute
  ReportsDashboardRoute: typeof ReportsDashboardRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
  ReportsIndexRoute: typeof ReportsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox': {
      id: '/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof InboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite': {
      id: '/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof InviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/views': {
      id: '/views'
      path: '/views'
      fullPath: '/views'
      preLoaderRoute: typeof ViewsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/audit': {
      id: '/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/automations': {
      id: '/admin/automations'
      path: '/automations'
      fullPath: '/admin/automations'
      preLoaderRoute: typeof AdminAutomationsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/export': {
      id: '/admin/export'
      path: '/export'
      fullPath: '/admin/export'
      preLoaderRoute: typeof AdminExportRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/groups': {
      id: '/admin/groups'
      path: '/groups'
      fullPath: '/admin/groups'
      preLoaderRoute: typeof AdminGroupsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/lookups': {
      id: '/admin/lookups'
      path: '/lookups'
      fullPath: '/admin/lookups'
      preLoaderRoute: typeof AdminLookupsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/tokens': {
      id: '/admin/tokens'
      path: '/tokens'
      fullPath: '/admin/tokens'
      preLoaderRoute: typeof AdminTokensRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/card/$number': {
      id: '/card/$number'
      path: '/card/$number'
      fullPath: '/card/$number'
      preLoaderRoute: typeof CardNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/': {
      id: '/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$key': {
      id: '/projects/$key'
      path: '/projects/$key'
      fullPath: '/projects/$key'
      preLoaderRoute: typeof ProjectsKeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/': {
      id: '/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof ReportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/$dashboard': {
      id: '/reports/$dashboard'
      path: '/reports/$dashboard'
      fullPath: '/reports/$dashboard'
      preLoaderRoute: typeof ReportsDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AdminRouteRouteChildren {
  AdminAuditRoute: typeof AdminAuditRoute
  AdminAutomationsRoute: typeof AdminAutomationsRoute
  AdminExportRoute: typeof AdminExportRoute
  AdminGroupsRoute: typeof AdminGroupsRoute
  AdminLookupsRoute: typeof AdminLookupsRoute
  AdminTokensRoute: typeof AdminTokensRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminAuditRoute: AdminAuditRoute,
  AdminAutomationsRoute: AdminAutomationsRoute,
  AdminExportRoute: AdminExportRoute,
  AdminGroupsRoute: AdminGroupsRoute,
  AdminLookupsRoute: AdminLookupsRoute,
  AdminTokensRoute: AdminTokensRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  InboxRoute: InboxRoute,
  InviteRoute: InviteRoute,
  LoginRoute: LoginRoute,
  SearchRoute: SearchRoute,
  SettingsRoute: SettingsRoute,
  ViewsRoute: ViewsRoute,
  CardNumberRoute: CardNumberRoute,
  ProjectsKeyRoute: ProjectsKeyRoute,
  ReportsDashboardRoute: ReportsDashboardRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
  ReportsIndexRoute: ReportsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
